<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="mb-3">Your basket</h1>
                <div v-if="updatedShowRegForm">
                    <div class="card mb-3 rounded-16">
                        <div class="bg-light py-3 px-3 d-flex align-items-center gap-2 rounded-top   mb-3">
                            <b class="text-16">Your basket is empty</b>
                        </div>
                        <p class="px-3">You currently have no tyres in your basket. Please use the form below to begin.</p>
                    </div>
                    <div class="mb-4">
                        <slimline-reg-size-form
                            :postcode="postcode"
                            :options="sizeOptions"
                            :image-base-path="imageBasePath"
                        >
                        </slimline-reg-size-form>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12 mb-3">
                        <h2 v-if="upsells?.length > 0" class="fs-4 my-3 my-md-0 fw-bold">Choose your extras</h2>
                    </div>
                    <div class="col-12 col-md-7 col-lg-8 col-xl-9 pb-3">
                        <new-basket-upsells
                            :fitter="updatedBasket?.fitter_id"
                            :basket="updatedBasket"
                            :image-base-path="imageBasePath"
                            :fuel-env="fuelEnv"
                            :link-colour="linkColour"
                            :nav-button="updatedNavButton"
                        ></new-basket-upsells>
                        <template v-if="((!updatedShowRegForm && updatedNavButtonUrl?.includes('choose-fitter')) || updatedBasket.home_delivery) && updatedBasket?.products.length > 0"> 
                            <div class="toggle-route-wrapper">
                                <div class="bg-light py-3 px-3 d-flex align-items-center gap-2 rounded mb-3">
                                    <b class="text-16">Confirm your fitting method</b>
                                </div>
                                <div class="row row-cols-2 px-3 pb-3">
                                    <div
                                        class="col route-toggle"
                                    >
                                        <div
                                            :class="{ 'border-primary pe-none' : !updatedBasket.home_delivery }"
                                            class="card"
                                        >
                                            <label class="card-body cursor-pointer" for="flexSwitchCheckChecked">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <h4 class="m-0">Fully Fitted</h4>
                                                    <div
                                                        v-if="updatedBasket.home_delivery == false"
                                                        class="text-black bg-light fw-bold p-1 fs-12 uppercase rounded"
                                                    >
                                                        Selected
                                                    </div>
                                                </div>
                                                <p class="small my-2 mb-0">You can choose mobile or garage fitting at the next step</p>
                                                <p class="small my-2">
                                                    <i class="fa-solid text-primary fa-check-circle me-1"></i>
                                                    Fitting Included
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                    <div
                                        v-if="showHomeDeliveryPrices"
                                        class="col route-toggle"
                                    >
                                        <div
                                            :class="{ 'border-primary pe-none' : updatedBasket.home_delivery}"
                                            class="card"
                                        >
                                            <label class="card-body cursor-pointer" for="flexSwitchCheckChecked">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <h4 class="m-0">Tyre Delivery</h4>
                                                    <div
                                                        v-if="updatedBasket.home_delivery == true"
                                                        class="text-black bg-light fw-bold p-1 fs-12 uppercase rounded"
                                                    >
                                                        Selected
                                                    </div>
                                                </div>
                                                <p class="small my-2 mb-0">Tyres delivered straight to your door</p>
                                                <p class="small my-2">
                                                    <i class="fa-solid text-danger fa-times-circle me-1"></i>
                                                    Fitting NOT Included
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="hidden d-none">
                                        <input class="form-check-input float-start mx-2 cursor-pointer" type="checkbox" role="switch" id="flexSwitchCheckChecked" @change="toggleRoute((toggledHomeDelivery == true ? 1 : 0))"  v-model="toggledHomeDelivery" :checked="toggledHomeDelivery">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-if="registration?.length > 0 && !size">
                            <div class="row">
                                <div class="col-12">
                                    <div class="bg-light py-3 px-3 d-flex align-items-center gap-2 rounded-top mb-3">
                                        <b class="text-16">You've entered your registration: <span class="uppercase">{{ registration }}</span></b>
                                    </div>
                                    <p class="px-3">Click the continue button to choose your tyre size.</p>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="size?.length > 0 && updatedBasket?.products == null">
                            <div class="row">
                                <div class="col-12">
                                    <div class="bg-light py-3 px-3 d-flex align-items-center gap-2 rounded-top mb-3">
                                        <b class="text-16">Your chosen tyre size: {{ customTyreUrl }}</b>
                                    </div>
                                    <p class="px-3">Click the continue button to choose your tyres.</p>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="!updatedBasket?.fitter_id && updatedBasket?.products?.length == 0">
                            <div class="row">
                                <div class="col-12">
                                    <div class="bg-light py-3 px-3 d-flex align-items-center gap-2 rounded-top mb-3">
                                        <b class="text-16">Your chosen tyre size: {{ customTyreUrl }}</b>
                                    </div>
                                    <p class="px-3">Click the continue button to choose your tyres.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-5 col-lg-4 col-xl-3" v-if="!updatedShowRegForm">
                        <new-basket
                            :fitter="updatedBasket.fitter_id"
                            :basket="updatedBasket"
                            :button-url="updatedNavButtonUrl"
                            :button-text="updatedNavButtonText"
                            :price-bg-colour="priceBgColour"
                            :link-colour="linkColour"
                        ></new-basket>
                    </div>
                    <div class="col-12">
                        <a v-if="updatedNavButtonUrl" :href="updatedNavButtonUrl" class="d-block d-lg-none col-12 btn btn-primary mt-2 mb-3">{{ updatedNavButtonText }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import url_filters from '@shared/mixins/url_filters';
    export default {
        mixins: [
            url_filters
        ],
        emits: [
            'routeToggled'
        ],
        props: [
            'steps',
            'currentStep',
            'size',
            'showRegForm',
            'navButton',
            'basket',
            'sizeOptions',
            'homeDelivery',
            'sizeUrl',
            'customTyreUrl',
            'registration',
            'imageBasePath',
            'postcode',
            'fuelEnv',
            'priceBgColour',
            'inlineHeading',
            'linkColour',
            'showHomeDeliveryPrices'
        ],
        data() {
            return {
                updatedNavButton: this.navButton,
                updatedNavButtonUrl: this.navButton.url ? this.navButton.url : '',
                updatedNavButtonText: this.navButton.text ? this.navButton.text : '',
                toggledHomeDelivery: this.homeDelivery == 1 ? true : false,
                updatedBasket: this.basket,
                updatedShowRegForm: this.showRegForm,
                upsells: []
            }
        },
        provide() {
            return {
                'sizeUrl': this.sizeUrl
            }
        },
        mounted() {
            this.emitter.on('upsellsLoaded', data => {
                this.upsells = data;
            });
            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
                this.updatedShowRegForm = data?.button?.show_registration_size_form;
            });
            this.emitter.on('updateNavButton', data => {
                this.updatedNavButtonUrl = data.url;
                this.updatedNavButtonText = data.text;
            });
        },
        methods: {
            toggleRoute: function(data) {
                let vm = this;
                vm.emitter.emit('isLoading', true);

                axios.post('/ajax/toggle_home_delivery_route/' + data + '/0')
                .then(response => {
                    vm.emitter.emit('routeToggled', data);
                    if(response.data.home_delivery == 1) {
                        vm.emitter.emit('updateNavButton', {text: 'Continue to checkout', url: 'booking-details'});
                    } else {
                        vm.emitter.emit('updateNavButton', {text: 'Choose fitter', url: 'choose-fitter'});
                    }
                    vm.emitter.emit('updateBasket', response.data.basket);
                    vm.emitter.emit('isLoading', false);

                })
                .catch(error => {
                    vm.emitter.emit('isLoading', false);
                    console.error("There was an error!", error);
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    .route-toggle {
        border-width: 2px;
    }
    .fs-12 {
        font-size: 12px;
    }
    .inner-border{
        border: 1px solid #ccc;
    }
</style>